<script setup lang="ts">
import { cn } from '../../utils';

interface Props {
  title?: string;
  hoverable?: boolean;
  neon?: boolean;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  hoverable: false,
  neon: false,
});
</script>

<template>
  <div
    :class="cn(
      'flex flex-col rounded-xl border backdrop-blur-md transition-all duration-300',
      'bg-white dark:bg-slate-900/40 border-slate-200 dark:border-white/5',
      hoverable && 'hover:border-rad-red/30 hover:shadow-[0_0_30px_rgba(254,0,79,0.1)] cursor-pointer',
      neon && 'border-rad-red/20 shadow-[0_0_20px_rgba(254,0,79,0.1)]',
      props.class
    )"
  >
    <div v-if="title || $slots.header" class="flex items-center p-6 pb-0">
      <slot name="header">
        <h3 v-if="title" class="text-lg font-bold text-slate-900 dark:text-rad-white tracking-tight">{{ title }}</h3>
      </slot>
    </div>
    <div class="p-6 pt-4 flex-1 text-slate-600 dark:text-slate-300">
      <slot />
    </div>
    <div v-if="$slots.footer" class="flex items-center p-6 pt-0">
      <slot name="footer" />
    </div>
  </div>
</template>